import React from 'react';
import { navigate } from "gatsby"
import { Helmet } from "react-helmet"
import { Chip} from '@mui/material'
import CommonProduct, { headingLookup, toggleCtrl, filterInfo} from "../components/commonPage"
import DropdownButton from 'react-bootstrap/DropdownButton'
import Dropdown from 'react-bootstrap/Dropdown'
import parse from 'html-react-parser'
var _ = require('underscore')

const order_by = {'relevance':"Relevance",'lastModifiedDate':"Last Modified",'name': "Name - Alphabetical"}

function wrapEmRegexStyle(text, searchText) {
  // Since algolia only return the <em> bracketed result for the first instance of search term in string, regex style highlighting is used below.
  return (searchText == '') ? (text || '') : ((text || '').replace(new RegExp(searchText, 'ig'), "<em>$&</em>")) 
}

class IndexPage extends CommonProduct {

  constructor(props) {
    super(props);
    this.homepage = true

    this.state.openDrawer = false;

    this.handleChange = this.handleChange.bind(this)
    
  }

  styleElement:any = null;

  updateStyles = () => {
    const searchbar = document.getElementById('searchbar');
    const searchContainer = document.querySelector('.searchContainer');

    let css = '';

    if (searchbar) {
      const marginTop = searchbar.offsetHeight - 150;
      console.log(marginTop)
      css += `#container.home #copy { margin-top: ${marginTop}px !important; }\n`;
    }

    if (!this.styleElement) {
      this.styleElement = document.createElement('style');
      document.head.appendChild(this.styleElement);
    }

    this.styleElement.innerHTML = css;
  };

  componentDidMount() {
    this.updateStyles();
    window.addEventListener('resize', this.updateStyles);
    window.addEventListener('load', this.updateStyles);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateStyles);
    window.removeEventListener('load', this.updateStyles);
    if (this.styleElement && this.styleElement.parentNode) {
      this.styleElement.parentNode.removeChild(this.styleElement);
    }
  }

  handleChange(e) {
    this.state.value  = e.target.value
  }

  setHighlightStrMap(hlMap){  //  highlighting string map from search.tsx
    this.setState({highlightStrMap:hlMap})
  }

  setProdObjMapping(prodObjMapping, queryID)
  {
    this.state.prodObjMapping = prodObjMapping
    this.state.queryID = queryID
  }

  render() {

    let {pageNum,focus,mv_lookups,products,page_info,highlightStrMap,userData,order,filters,extra_validators,extra_spdc_option} = this.state

    let headingKeys = Object.keys(headingLookup)
    let filterLookup = {}
    if (focus!=null && !!mv_lookups.products)
    {
      let choice = headingKeys[focus-1]
      let fieldLookup = this.filterTree[choice]
      if (fieldLookup)
      {
        for (let fieldName of Object.keys(fieldLookup) )
        {
          _.extendOwn(filterLookup, mv_lookups.products[fieldName])
        }
      }
    }
    
    let BaseComponent = this.BaseComponentRender.bind(this)
    let localPath=''
    if (this.isBrowser)
    {
      localPath=location.protocol+'//'+location.host
    }

    const nextPage = page_info && (page_info.page+1) || 1;
    let showingCount = 0
    if (!!page_info)
    {
      showingCount = (nextPage)*page_info.hitsPerPage
      if (showingCount>page_info.nbHits)
      {
        showingCount = page_info.nbHits
      }
    }

    const loadMoreButton = page_info && (page_info.nbPages>nextPage) || false
    const filterCount = (extra_spdc_option?1:0)+(extra_validators? extra_validators.length:0)+filters.length

    const extraTopHTML = <>
        <div id="homepageMessage">
          <h2>Helping Schools Select Better EdTech Tools!</h2>
          Each year, educators spend countless hours evaluating edtech tools for student use. The EdTech Index streamlines this process by providing comprehensive information about educational technology products—including quality indicators and credible third-party certifications—all in one searchable database. This free service helps schools make informed decisions quickly, redirecting valuable time to teaching and learning. Made possible by generous donors, the EdTech Index is your trusted evaluation resource.
        </div>    
    </>

    return (
      <>        
      <Helmet>
        <meta property="og:title" content="ISTE Learning Technology Directory" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://index.edsurge.com/" />
        <meta property="og:image" content="https://index.edsurge.com/images/EdSurge_Bolt_Symbol_Green.png" />
        <meta property="og:image:width" content="1200"/>
        <meta property="og:image:height" content="630"/>
        <meta property="og:description" content="EdTech Index" />
      </Helmet>
    
      <BaseComponent controller={this} extraTopHTML={extraTopHTML} homepage={true} menu="home" title="Homepage | EdTech Index">

        <div className={this.state.openDrawer?"products open":"products"} key="products">

        <div id="topInformation">
          <div id="results">
          <div className="showing">
              Showing {showingCount} of {page_info && page_info.nbHits || 0} results
            </div>
            <span className="hide_mobile">Order by</span>
                <DropdownButton className="dropdown" title={order_by[order]}>
                  {

                    Object.keys(order_by).map((fieldName, index)=>{
                      let heading = order_by[fieldName]
                      let updateResults = this.updateResults.bind(this)
                      let bound_values:any = {unique_id:'order',state:fieldName,controller:this,save_group:'results',onUpdate:updateResults}
                      let toggler:toggleCtrl = new toggleCtrl(bound_values)
                      let clickFunction = toggler.changeSelection.bind(toggler)
                      return <Dropdown.Item key={"order_"+fieldName} onClick={clickFunction} >{heading}</Dropdown.Item>
                    })
                  }
                </DropdownButton>
          </div>

          <div className="allFilters">
          {
            filterInfo.map( (info, index ) => {
              return <div key={'ql'+index} onClick={()=>{this.setState({showExploration:true, exploreChoice:info.choice})}} className={`quicklink ${info.iconClass}`}><span>{info.label}</span>
              {
                (filterCount>0 && index==(filterInfo.length-1)) && <div className='circle'>{filterCount}</div>
              }</div>
            })
          }
          </div>

        </div>

        {
            (products.length>0)  &&
            products.map( (product,index) => {
              if (!!product)
              {
                let product_key = 'product_'+product.productKey

                let updateMyList = this.updateMyList.bind(this)
                let my_list_state = this.state[product_key]
                let my_new_state = (!!my_list_state)?null:product.name
                let bound_values:any = {unique_id:product_key,state:my_new_state,controller:this,save_group:'my_list',onUpdate:updateMyList,
                    eventTrack: {type:'Add to my list', properties:{product_key:product.productKey,state:(my_new_state)?'add':'remove'}},
                  }
                let toggler:toggleCtrl = new toggleCtrl(bound_values)

                let clickFunction = toggler.changeSelection.bind(toggler)
                if (!userData || !userData.login) clickFunction = ()=>{this.setState({showLogin: true})}

                const highlights = highlightStrMap[product.productKey]

                let nameHighlightedRegexStyle= (highlights && highlights['name']?.value) || wrapEmRegexStyle(product.name, this.state.searchTerm)

                let descHighlightedRegexStyle= (highlights && highlights['publicDescription']?.value) || wrapEmRegexStyle(product.publicDescription, this.state.searchTerm)

                let organizationNameHighlightedRegexStyle= (highlights && highlights['organizationName']?.value) || wrapEmRegexStyle(product.organizationName, this.state.searchTerm)

                return <div className={(index==0)?"product first":"product"} key={'productwrap_'+product.productKey+`_indx${index}`}>
                    <div className="clickArea" onClick={()=>{this.productTrack(product, index+pageNum*page_info.hitsPerPage);navigate((!!product.ultid)?"/product/?ultid="+product.ultid:"/product/?recordId="+product.productKey)}}>
                      { product.featuredRank && <div className="featured">Featured Product</div> }
                      {
                        product.image_url &&
                        <div className="imgHolder"><img src={product.image_url} alt={product.name+" image"} /></div>
                      }
                      <strong onClick={()=>{this.productTrack(product, index+pageNum*page_info.hitsPerPage);navigate((!!product.ultid)?"/product/?ultid="+product.ultid:"/product/?recordId="+product.productKey)}}>{parse(nameHighlightedRegexStyle)}</strong>
                      <span className="byline">by {parse(organizationNameHighlightedRegexStyle)}</span>
                      {
                        (this.state.display_style=='list') &&
                        product.mv_items.map((filterKey,fIndx) => {
                          if (filterLookup[filterKey])
                          {
                            let highlightedChip = wrapEmRegexStyle( filterLookup[filterKey], this.state.searchTerm)
                            return <Chip key={product.productKey+'_'+filterKey} label={parse(highlightedChip)}/>
                          }
                        })
                      }
                      
                      <p className="desc">{parse(descHighlightedRegexStyle)} </p>
                    </div>
                    <div className="moreLink" onClick={()=>{this.productTrack(product, index+pageNum*page_info.hitsPerPage);navigate((!!product.ultid)?"/product/?ultid="+product.ultid:"/product/?recordId="+product.productKey)}}></div>

                    <div className="listButton">
                      {
                        my_list_state && <div className='compare' onClick={()=>{navigate("/my_list/")}}></div>
                      }
                      <button className={my_list_state?'selected':'deselected'} onClick={clickFunction}>{my_list_state?'':'Add to list'}</button>
                    </div>
                  </div>
              }
            })
          }
        </div>
        {
          loadMoreButton && <div className={this.state.openDrawer?"loadMore open":"loadMore"} onClick={()=>{this.setState({initSearch:false,pageNum:nextPage})}}>Load more</div>
        }
        <div id="linkBar" className={this.state.openDrawer && "open"}>
          <a id="vendorLogin" href="https://ltd.iste.org/" target="_blank">Vendor Login</a>
        </div>
        <div id="initiative" className="partner_group">
          <div className='label'>EdTech Index is an initiative of:</div>
          <div className="partners">
            <div className="partner_div"><a href="https://iste.org/" target="_blank"><img src="../images/new/iste-ascd_stacked_color_v1.png" alt="ISTE"/></a>                      </div>
            <div className="partner_div"><a href="https://www.cosn.org/" target="_blank"><img src="../images/new/COSN_transparent.png" alt="CoSN"/></a>           </div>
            <div className="partner_div"><a href="https://digitalpromise.org/" target="_blank"><img src="../images/new/DigitalPromise.png" alt="Digital Promise"/></a>                      </div>
            <div className="partner_div"><a href="https://www.setda.org/" target="_blank"><img src="../images/new/sedta-2.png" alt="SETDA"/></a>                      </div>
            <div className="partner_div"><a href="https://www.1edtech.org/" target="_blank"><img src="../images/new/1EdTechLogo.png" alt="1EdTech"/></a>           </div>
            <div className="partner_div"><a href="https://www.cast.org/" target="_blank"><img src="../images/CAST-logo-purple.png" alt="CAST"/></a>           </div>
            <div className="partner_div"><a href="https://www.innovateedunyc.org/" target="_blank"><img src="../images/new/InnovateEDU.png" alt="InnovateEDU"/></a>     </div>
          </div>
        </div>
        <div id="supporters" className="partner_group">
          <div className='label'>EdTech Index Education Partners:</div>
          <div className="partners">
            <div className="partner_div fdn"><a href="https://schools.utah.gov/" target="_blank"><img src="../images/new/UtahBOE.png" alt="Utah State Board of Education"/></a>           </div>
          </div>
        </div>
        <div id="supporters" className="partner_group">
          <div className='label'>EdTech Index is made possible by the generous support of:</div>
          <div className="partners">
            <div className="partner_div fdn"><a href="https://www.gatesfoundation.org/" target="_blank"><img src="../images/new/Gates_Foundation_Logo.png" alt="Bill and Melinda Gates Foundation"/></a>           </div>
            <div className="partner_div fdn"><a href="https://www.dell.org/" target="_blank"><img src="../images/new/MichaelSusanDellFoundation.png" alt="Michael and Susan Dell Foundation"/></a>                       </div>
            <div className="partner_div"><a id="poweredByAWS" href="https://aws.amazon.com/what-is-cloud-computing"><img src="../images/new/AWS_logo_RGB.png" alt="Powered by AWS Cloud Computing" /></a></div>
          </div>
        </div>

      </BaseComponent>
      </>
    )
  }
}
export default IndexPage
